import Vue from "vue";
import Router from "vue-router";
import routers from "./modules";
import i18n from "@/i18n/index";
Vue.use(Router);

const router = new Router({
	mode: (process.env.NODE_ENV === "development" || process.env.isOffline) ? "hash" : "history",
	base: "/appweb/knowledge/",
	routes: routers,
	// routes: (r => {
	// 	return r.keys().map(key => r(key).default);
	// })(require.context("./modules", true, /\.js$/)),
	scrollBehavior() {
		return {y: 0};
	}
});

router.beforeEach((to, from, next) => {
	const cmbiLang = to.query.lang || to.query.cmbiLang || localStorage.getItem("locale") || "zh-cn"
	localStorage.setItem("locale", cmbiLang)
	// document.title = i18n.t("router.title")
	//常规操作
	next();
});

export default router;
